import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RadioButton } from 'primereact/radiobutton';

// service
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { LinkProviderService } from "../../../service/LinkProviderService";

// actions
import { getUsagerInfo } from "../../../store/actions/usager";
import { setListActionSociale, setCAS } from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";

// scss
import "./FormulaireClap.scss";

export const ChoixFormulairePrestation = () => {
  const { casCodeList } = useParams();
  const actionSociale = useSelector((state) => state.actionSociale);
  const dispatch = useDispatch();
  const [listActionSociales, setListActionSociales] = useState([]);
  const [selectedActionSociale, setSelectedActionSociale] = useState(null);
  const [displayedAS, setDisplayedAS] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);

  const actionSocialeService = new ActionSocialeService();
  const linkService = new LinkProviderService();

  useEffect(() => {
    callUsagerInfoApi();
  }, []);

  useEffect(() => {
    dispatch(setListActionSociale(listActionSociales));
    displayActionSociale();
  }, [listActionSociales]);

  useEffect(() => {
    dispatch(setCAS(selectedActionSociale));
  }, [selectedActionSociale]);

  const callUsagerInfoApi = () => {
    dispatch(getUsagerInfo()).then((res) => {
      if (res != null && res != undefined) {
        getActionSocialesDematByCASAndDlg(res.codeDelegation);
      }
    })
  };

  const getActionSocialesDematByCASAndDlg = (codeDelegation) => {
    const listCas = casCodeList.split(',');
    listCas.forEach(cas => {
      actionSocialeService.getActionSocialeDematByCASAndDlg(cas, codeDelegation).then(
          (response) => {
            Object.values(response.data).map(item => {
                setListActionSociales(current => [...current, item]);
            });
          }
      );
    });
  };

  const displayActionSociale = () => {
    listActionSociales.map(as => {
      if(!displayedAS.some(dAS => dAS.codeActionSociale === as.codeActionSociale)) {
        setDisplayedAS(prevState => [...prevState, as]);
      }
    })
  };

  return (
    <div className="grid cld-width" style={{ marginTop: "1%" }}>
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card">
          <nav aria-label="breadcrumb" class="pt-3">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href={linkService.getRetourEaAccueilAgent()} target="_self">
                  Espace Agent
                </a>
              </li>

              <li className="breadcrumb-item">
                <a href={linkService.getRetourEaMembrePrestation()} target="_self">
                  Prestations et Formulaires
                </a>
              </li>

              <li aria-current="page" className="breadcrumb-item active">
                Demande d'une prestation
              </li>
            </ol>
          </nav>
          <p></p>
          <h2 className="cld-h2" style={{ marginTop: "2%",marginBottom: "2%" }}>La prestation concernée</h2>
          <div style={{ backgroundColor: "#E9ECEF", paddingLeft: "1%", paddingTop: "1%", paddingBottom: "2%", borderRadius: "5px"}}>
            {displayedAS && displayedAS.length > 0 && displayedAS.map(element =>
              <div key={element.codeActionSociale} style={{marginTop: "1%"}}>
                <RadioButton inputId={element.key} name="CAS_RADIO" value={element.codeActionSociale} onChange={(e) => setSelectedActionSociale(e.value)} checked={selectedActionSociale === element.codeActionSociale} />
                <b>  &nbsp;&nbsp;&nbsp;{element.codeLibelle} </b>
              </div>
            )}
          </div>
          {(listActionSociales && listActionSociales.length > 0) &&
              <div className="next-button-wrapper">
                  {
                    selectedActionSociale
                        ? <Link to={"/choixPeriode"} className="next-button-link" onClick={actionSocialeService.persistState(actionSociale)}>
                            <button type="button" className="next-button button-arrow">Etape suivante</button>
                          </Link>
                        : <Link to={""} className="next-button-link" style={{ pointerEvents: "none" }}>
                            <button type="button" className="next-button button-arrow disabled">Etape suivante</button>
                          </Link>
                  }
              </div>
          }
        </div>
      </div>
    </div>
  );
};
